import type { ChapterGateStatus } from './types'

/** 门控状态给人看的短标签（勿直接暴露 drafting 等英文） */
export function gateStatusLabel(status: ChapterGateStatus | string | undefined): string {
  switch (status) {
    case 'locked':
      return '未开'
    case 'open':
      return '可写'
    case 'drafting':
      return '写作中'
    case 'review':
      return '门控中'
    case 'passed':
      return '已过'
    case 'needs_revision':
      return '待改'
    default:
      return '可写'
  }
}

/** 「第一章 绪论」→「绪论」 */
export function shortChapterTitle(full: string): string {
  return full.replace(/^第[一二三四五六七八九十\d]+章\s*/, '').trim() || full
}
